import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router";
import * as Scroll from "react-scroll";

import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import {
  getDecodedToken,
  isOffshoreInvestment,
  logEvents,
  trackEventWithScreen,
} from "../../utils/functions";
import {
  FINANCIAL,
  FINANCIALTAB,
  OFFSHORE,
  PORTFOLIO_PAGE,
} from "../../utils/constants";

const Portfolio = observer(() => {
  const location = useLocation();
  const {
    // assetClassId, vehicleId,
    // instrumentId,
  } = useParams();
  const pathname = location.pathname;
  const [isLoading, setIsLoading] = useState(true);
  const [locationState, setLocationState] = useState("");

  useEffect(() => {
    const abortController = new AbortController();
    const pathArray = pathname.split("/");

    if (
      UserStore.isHydrated &&
      PerformanceStore.isHydrated &&
      pathArray.length === 2
    ) {
      const locationFromTab = location?.state?.from;

      if (!locationState) {
        setLocationState(locationFromTab);
      }

      if (!locationFromTab || !locationState) {
        setIsLoading(true);
        //setInfinityAbort(abortController);
        const { signal } = abortController;
        AuthStore.updateLoadingFullScreen(true);

        // Fetch portfolio asset class page apis data
        setIsLoading(false);

        // Event Tracking
        trackEventWithScreen({
          eventName: PORTFOLIO_PAGE,
          screenName: FINANCIAL,
        });
        logEvents(PORTFOLIO_PAGE, { screenName: FINANCIAL });

        UserStore.setInfinityInstrumentIds({
          assetClassId: null,
          vehicleId: null,
        });
        PerformanceStore.loaderCloseOnFail();

        // Select financial asset or global tab
        const locationFrom = location?.state?.from;
        const tabName =
          locationFrom && locationFrom === OFFSHORE ? OFFSHORE : FINANCIALTAB;
        UserStore.setSelectedTab(tabName);

        // For calling apis with default state of isInfinity = 0 and isLive = 0
        UserStore.changeIsLiveToZero("0", false);
        UserStore.setNormalHybirdFlow(false);
        UserStore.removeInfinity();
        //UserStore.setIsInfinityPopulated(false);

        if (!UserStore.portfolioTabsStatus[tabName]) {
          // Set loaders to loading state
          PerformanceStore.setCurrentLoader("portfolioAssetPageLoader");
          PerformanceStore.setPerformanceLoader(
            "portfolioAssetPageLoader",
            true,
          );
          window.scrollTo(0, 0);
          AuthStore.updateLoadingFullScreen(true);

          UserStore.setSelectedTab(tabName);

          function getPortfolioData({ signal }) {
            UserStore.populatePortfolio(
              { isScroll: false, measureId: undefined, signal },
              false,
            );
            UserStore.getQuickViews({ signal });
            if (getDecodedToken()?.user_type !== "manager") {
              UserStore.getFamilyClients(
                "forImg",
                () => {},
                () => {},
                signal,
              );
            }
          }

          // API call
          if (tabName === FINANCIALTAB) {
            getPortfolioData({ signal });
          } else {
            if (isOffshoreInvestment()) {
              UserStore.populateOffshorePortfolio({
                isScroll: false,
                signal,
              });
            } else {
              UserStore.setSelectedTab(FINANCIALTAB);
              getPortfolioData({ signal });
            }
          }
        }
      }
    }

    return () => {
      abortController.abort();
    };

    // eslint-disable-next-line
  }, [UserStore.isHydrated, PerformanceStore.isHydrated, location]);

  useEffect(() => {
    const pathArray = pathname.split("/");

    if (
      !AuthStore.isLoadingFullScreen &&
      UserStore.isHydrated &&
      PerformanceStore.isHydrated &&
      pathArray.length === 2
    ) {
      setTimeout(() => {
        const itemToScroll = document.getElementById(
          `${UserStore.selectedRefId}`,
        );

        itemToScroll &&
          Scroll.animateScroll.scrollTo(
            itemToScroll?.getBoundingClientRect()?.top,
            {
              isDynamic: true,
              duration: 1700,
              smooth: true,
              delay: 100,
            },
          );
        itemToScroll && UserStore.setRef("", "normal");
      }, 100);
    }

    // eslint-disable-next-line
  }, [
    UserStore.isHydrated,
    PerformanceStore.isHydrated,
    UserStore?.portfolio?.clientAssetClass,
    AuthStore.isLoadingFullScreen,
    location,
    locationState,
  ]);

  useEffect(() => {
    UserStore.setPortfolioTabsStatusDefault();
    return () => {
      PerformanceStore.loaderCloseOnFail();
      UserStore.setRef("", "normal");
      UserStore.setPortfolioObj({});
      UserStore.setPortfolioTabsStatusDefault();
      UserStore.setUserData("offshoreData", {});
      UserStore.setAssetTabsData([]);
      UserStore.setOpenId("infinityOpenID", null);
      UserStore.setOpenId("portfolioOpenID", null);
      UserStore.setOffShoreAssetDataToDefault();
    };
  }, []);

  return (
    <>
      <Outlet
        context={{
          isLoading,
          type: "portfolio",
          setIsLoading: (data) => {
            setIsLoading(data);
          },
          setLocationState: (data) => {
            setLocationState(data);
          },
        }}
      />
      {/* <div>
        {AuthStore.isLoadingFullScreen ||
        !UserStore.isHydrated ||
        isLoading ||
        PerformanceStore.portfolioAssetPageLoader ? (
          <LoadingScreen />
        ) : (
          <>
            <Header type="portfolio" />
            <div className="portfolio1_below_header_container">
              <div className="portfolio1_below_header">
                {!location.pathname.includes("_portfolio") && (
                  <BreadCrumb
                    locationArr={
                      pathname === "/portfolio" ? [] : UserStore.portfolioPath
                    }
                    // clickFunction={(index, data) =>
                    //   handleBreadClick(index, data)
                    // }
                    parentName={"portfolio"}
                  />
                )}
              </div>

              <Outlet context={[setIsInfinityUnmounted]} />
            </div>
          </>
        )}
      </div> */}
    </>
  );
});

export default Portfolio;
